'use client';

import animationData from '@/animations/feature-help-desk.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationFeatureHelpDeskProps {
  playing?: boolean;
}

const AnimationFeatureHelpDesk: FC<AnimationFeatureHelpDeskProps> = ({ playing }) => {
  return (
    <div className="aspect-[396/348]">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationFeatureHelpDesk;
